import type { ComponentProps } from 'react';
import type { SingleComboBox } from '@itandi/itandi-bb-ui/SingleComboBox';
import type { Leasing } from '~/models/Leasing';

export type PropertyBuildingOption = {
  key: string;
  label: string;
  name: string;
  zipCode: string | null;
  address: string;
  amaterasPropertyId: number | null;
  placeKeyStoring: string | null;
  freeParking: string | null;
  enableElevator: 'true' | 'false' | null;
  enableAutoLock: 'true' | 'false' | null;
};

type ComboBoxOption = Exclude<
  ComponentProps<typeof SingleComboBox>['options'][number],
  { group: string }
>;
type ComboBoxValue = ComponentProps<typeof SingleComboBox>['value'];

export const buildBuildingOption = (
  propertyOption: PropertyBuildingOption
): ComboBoxOption => ({
  label: propertyOption.label,
  description:
    propertyOption.key === 'manual-input-building'
      ? 'Tabキー、または、クリックで新規登録'
      : propertyOption.address,
  value: propertyOption.key
});

export const buildingOptions = (
  propertyOptions: PropertyBuildingOption[]
): ComboBoxOption[] => propertyOptions.map(buildBuildingOption);

export const propertyBuildingOptionValue = (
  propertyOption: PropertyBuildingOption | null
): ComboBoxValue => {
  if (propertyOption === null) return null;
  return {
    label: propertyOption.label,
    value: propertyOption.key
  };
};

export const buildPropertyBuildingOptionsFromRoomName = (
  roomName: string
): PropertyBuildingOption[] => {
  if (roomName === '') return [];

  return [
    {
      key: 'manual-input-building',
      label: roomName,
      name: roomName,
      zipCode: null,
      address: '',
      amaterasPropertyId: null,
      placeKeyStoring: null,
      freeParking: null,
      enableElevator: null,
      enableAutoLock: null
    }
  ];
};

export const buildPropertyBuildingOptionsFromLeasing = (
  leasing: Leasing | null
): PropertyBuildingOption | null => {
  if (!leasing?.roomName) return null;

  return {
    key: `leasing-property-building-${leasing.id}`,
    label: leasing.roomName,
    name: leasing.roomName,
    zipCode: null,
    address: leasing.address ?? '',
    amaterasPropertyId: leasing.amaterasBuildingPropertyId,
    placeKeyStoring: null,
    freeParking: null,
    enableElevator: null,
    enableAutoLock: null
  };
};
